import Field from './field';

const JS_LABEL = '[js-label]';
const JS_LANGUAGE = 'js-language';
// Auto add * after label
class Required extends Field{
    constructor(form, error, element) {
        super();
        this.form = form;
        this.element = element;
        this.error = error;

        this.fields = this.getFields(this.element);
        this.language = this.form.getAttribute(JS_LANGUAGE);

        this.checkRequired();
        
    }
    requiredMessage(labelText) {
        switch(this.language) {
            case 'nl':
                return `Het '${labelText.replace('*','').trim()}' veld is verplicht.`;
            case 'en':
                return `The '${labelText.replace('*','').trim()}' field is required.`;
            case 'de':
                return `Das Feld '${labelText.replace('*','').trim()}' ist erforderlich.`;
            case 'es':
                return `El campo '${labelText.replace('*','').trim()}' es obligatorio.`;
            case 'fr':
                return `Le champ '${labelText.replace('*','').trim()}' est obligatoire.`;
            default:
                return `The '${labelText.replace('*','').trim()}' field is required.`;
        }
    }

    requiredAtLeastOneMessage(labelText) {
        switch(this.language) {
            case 'nl':
                return `Vul tenminste 1 van de volgende velden in: ${labelText.trim().slice(0, -1)}.`;
            case 'en':
                return `Fill in at least 1 of the following fields: ${labelText.trim().slice(0, -1)}.`;
            case 'de':
                return `Füllen Sie mindestens eines der folgenden Felder aus: ${labelText.trim().slice(0, -1)}.`;
            case 'es':
                return `Complete al menos 1 de los siguientes campos: ${labelText.trim().slice(0, -1)}.`;
            case 'fr':
                return `Remplissez au moins 1 des champs suivants: ${labelText.trim().slice(0, -1)}.`;
            default:
                return `Fill in at least 1 of the following fields: ${labelText.trim().slice(0, -1)}.`;
        }
    }

    checkRequired() {
        const requiredValue = this.element.getAttribute('js-required');
        
        if(requiredValue) {
            let hasValue = 0;
            const requiredItems = [...this.form.querySelectorAll(`[js-required=${requiredValue}]`)];
            let labelText = '';
            requiredItems.forEach(item => {
                if(this.hasValue(this.getFields(item))) hasValue++;
                const label = item.querySelector(JS_LABEL).innerText;
                if(label != undefined) labelText += `'${label.replace('*','').trim()}', `;
            })
            this.error.errorData(!hasValue, `required`, this.fields, this.element, this.requiredAtLeastOneMessage(labelText));
        } else {
            const labelText = this.element.querySelector(JS_LABEL).innerText;
            let hasError = !this.hasValue(this.fields) ? true : false;

            this.error.errorData(hasError, `required`, this.fields, this.element, this.requiredMessage(labelText));   
        }

    }
}

export default Required;
